import * as React from 'react';

export const DirectBiddingDisclaimerContext = React.createContext<boolean>(false);
